import { render, staticRenderFns } from "./text-modal-without-cancel.vue?vue&type=template&id=5fc71c0b&scoped=true&"
import script from "./text-modal-without-cancel.vue?vue&type=script&lang=js&"
export * from "./text-modal-without-cancel.vue?vue&type=script&lang=js&"
import style0 from "./text-modal-without-cancel.vue?vue&type=style&index=0&id=5fc71c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc71c0b",
  null
  
)

export default component.exports